import { MemberService } from "components/member-service/MemberService";
import CardTemplate from "components/card/card-template/CardTemplate";
import { HoursOperation } from "components/hours-operation/HoursOperation";
import React from "react";
import CallToActionButton from "components/form-fields/call-to-action-button/CallToActionButton";
import { useQuote } from "hooks/useQuote";
import { useOffer } from "hooks/useOffer";

interface DeniedDecisionProps {
    navigateTo?: string;
}

const DeniedDecision = ({ navigateTo = "/quote" }: DeniedDecisionProps) => {
    // ========== Hooks ==========
    const { quoteData } = useQuote();
    const { offerData } = useOffer();

    // ========== State ==========

    // ========== Computed Values ==========
    const applicantType = quoteData?.applicantType ?? "member";
    const memberOfferAvailable = offerData?.memberOfferAvailable ?? true;
    const spouseOfferAvailable = offerData?.spouseOfferAvailable ?? true;

    // ========== Render ==========
    return (
        <CardTemplate title="We're Sorry" className="text-base-content">
            <div className="font-medium text-base-content text-base flex flex-col gap-5">
                <p className="leading-6" id={`denied-decision-to-${applicantType}`}>
                    {applicantType === "member"
                        ? "We are unable to approve the application that you submitted for Direct Term Life Insurance. You will receive a letter in the mail in the near future that provides more details about this decision."
                        : "We are unable to approve your spouse's application that you submitted for Direct Term Life Insurance. You will receive a letter in the mail in the near future that provides more details about this decision."}
                </p>

                <p className="leading-6 text-sm">
                    If you have further questions or wish to learn about our other life insurance options that may be available,
                    please contact our Member Service Advocates.
                </p>

                <MemberService />

                <HoursOperation />

                <CallToActionButton
                    applicantType={applicantType}
                    memberOfferAvailable={memberOfferAvailable}
                    spouseOfferAvailable={spouseOfferAvailable}
                    navigateTo={navigateTo}
                />
            </div>
        </CardTemplate>
    );
};

export default DeniedDecision;
